import { ArrowForward } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { SvgEnAttenteValidation, SvgValidationCompte, SvgValidationCompte2 } from '../../data/SVGs';
import useAuth from '../../hooks/useAuth';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useRole from '../../hooks/useRole';
import useWindowSize from '../../hooks/useWindowSize';
import { DateValidationEntrprise, isNonPermittedRoute, isNonPermittedRouteForNewClientOwner, isUrlFromCompleterProfile } from '../../Utils/utils';

function HomeClient() {

    //const [isInvAttente,setIsInvAttente]=useState();
    const navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();
    const role = useRole();
    // const currentUserStep=useStep();
    const currentUserStep = auth.completeStep;
    const [scenario, setScenario] = useState('');
    const [companyName, setCompanyName] = useState('');
    const { pathname } = useLocation();
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    useEffect(() => {
        if (currentUserStep != null && role) {
            getScenarioCollaborator();
        }
    }, [pathname, currentUserStep, scenario, role]);

    const getScenarioCollaborator = async () => {
        try {
            const response1 = await axiosPrivate.get(`/${role}/getMyInfos`);

            let response;
            try {
                response = await axiosPrivate.get('docAdministratif/getMyDocsAdministratifs');
            } catch (error) {
                console.log('error',error);
            }
            console.log('PP', 'currentUserStep', currentUserStep,'companyIsValid', DateValidationEntrprise(response?.data)?.isValide);
            //* scenario 1 : si le client à arriver dans le step 3, il'a envoyer une invitation et il est en attente de validation
            if (currentUserStep == 3 && Object.values(response1?.data?.collaborator?.roles ?? response1?.data?.collaboratorEsn?.roles).every(x => x == 0)) {
                setScenario('1');
                console.log('1');
                const response3 = await axiosPrivate.get(`/${role}/getMySentInvitation`);
                setCompanyName(response3?.data?.companyName);
                if(pathname == `/${role}`)
                    navigate(`/${role}/cvTheque`); //* before finding the idea of index
            }
            //* scenario 2 : si le client à completer son profil, il est en attente de validation de son compte par le backOffice
            else if (currentUserStep == 5 && !DateValidationEntrprise(response?.data)?.isValide) {
                setScenario('2');
                console.log('2');
                if(pathname == `/${role}`)
                    navigate(`/${role}/cvTheque`); //* before finding the idea of index
            }
            //* scenario 3 : le client n'a pas complété son profile (on le redirege vers le step où il a arrêté )
            // ! pb de detection de ce scenarios : c'est pas un else .. fixed
            else if(currentUserStep < 5) {
                setScenario('3');
                console.log('3');

            }
            else{
                console.log('you are clean to go', pathname);
                if(pathname == `/${role}`)
                    navigate(`/${role}/cvTheque`); //* before finding the idea of index
            }
        } catch (error) {
            console.log(error);
        }
    };
    // !
    // console.log('scenario != ',scenario != ''  && !isUrlFromCompleterProfile(pathname),'scenario == 1 ',scenario == '1' );
    // console.log('permitted route',isNonPermittedRoute(pathname, role));
    return (
        <>
            {/* TODO */}
            {scenario != ''  && !isUrlFromCompleterProfile(pathname) ?
                <>
                    {scenario == '1' &&
                    (
                        isNonPermittedRoute(pathname, role) ?
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    paddingTop: '15%',
                                    width: device=='desktop'?'80%':'100%',
                                    gap: '24px',
                                }}
                            >
                                <h3 className='frame32433243'>{i18n.t('Invitation est en attente!')} </h3>
                                <SvgValidationCompte2 width={device=='desktop'?'383':'250'}/>
                                {/* <h4 className='titlesociete'>Votre demande de rejoindre l&apos;entreprise est en attente d&apos;acceptation. Vous serez notifié par mail après sa validation.</h4> */}
                                <h4
                                    className='titlesociete'
                                    style={{textAlign:'center',fontSize:device=='desktop'?'34px':'22px'}}
                                >{i18n.t('Votre demande pour rejoindre')} “{companyName}” {i18n.t('est en cours de traitement et en attente d\'acceptation. Vous recevrez une notification par e-mail dès qu\'elle sera validée.')}</h4>
                            </div>
                            :
                            <Outlet />
                    )
                    }
                    {scenario == '2' &&
                    (
                        isNonPermittedRouteForNewClientOwner(pathname, role) ?
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    width: device=='desktop'?'80%':'100%',
                                    paddingTop: '15%',
                                    gap: '24px',
                                }}
                            >
                                <h3 className='frame32433243'>{i18n.t('L\'activation du compte est en cours...')}</h3>
                                <SvgEnAttenteValidation width={device=='desktop'?'383':'250'}/>
                                <h4
                                    className='titlesociete'
                                    style={{textAlign:'center',fontSize:device=='desktop'?'34px':'22px'}}
                                >{i18n.t('Vous allez recevoir un e-mail qui va vous informer de l\'activation de votre compte par notre équipe dans les prochaines heures.')}</h4>
                            </div>
                            :
                            <Outlet />
                    )
                    }
                    {scenario == '3' &&
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                width: device=='desktop'?'80%':'100%',
                                paddingTop: '15%',
                                gap: '24px',
                            }}
                        >
                            <h3 className='frame32433243' > {i18n.t('Finalisez votre profil!')} </h3>
                            <SvgValidationCompte width={device=='desktop'?'432':'250'}/>
                            <h4
                                className='titlesociete'
                                style={{display:'flex',justifyContent:'center',fontSize:device=='desktop'?'34px':'22px'}}
                            >
                                {i18n.t('Finalisez votre profil en cliquant ici')}
                                <IconButton
                                    //contained
                                    style={{ width: '50px' }}
                                    sx={{ color: '#272D3C', padding: '0px' }}
                                    onClick={() => {
                                        const commonCompleteProfilePath = `/${role}/completeProfile`;
                                        if (currentUserStep < 2)
                                            navigate(`${commonCompleteProfilePath}`);
                                        else if (currentUserStep === 2)
                                            navigate(`${commonCompleteProfilePath}/step2`);
                                        // Client pass directly from 2 to 4
                                        else if (currentUserStep === 4)
                                            // else if (currentUserStep === 4 && scenario=='4')
                                            navigate(`${commonCompleteProfilePath}/step4`);
                                    }}
                                >
                                    <ArrowForward />
                                </IconButton> </h4>
                        </div>
                    }
                </>
                :
                <Outlet />
            }
        </>
    );
}

export default HomeClient;